import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_IDD,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);

export const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
export const signInWithGoogle = () => {
  auth.signInWithRedirect(googleAuthProvider);
};

export const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
export const signInWithFacebook = () => {
  	auth.signInWithRedirect(facebookAuthProvider);
};

auth.getRedirectResult().then(function(result) {
}).catch(function(error) {
  	if (error.code == 'auth/account-exists-with-different-credential') {
	    var provider = new firebase.auth.GoogleAuthProvider();
	    provider.setCustomParameters({login_hint: error.email});
	    firebase.auth().signInWithRedirect(googleAuthProvider)
	}
});

export const firestore = firebase.firestore();
